import { motion } from "framer-motion";
import { OnboardingStep } from "@/generated-api";
import { useTranslation } from "@/hooks/useTranslation";

export default function StepTracker({ step }: { step: OnboardingStep }) {
  const t = useTranslation();
  const steps = [
    { key: OnboardingStep.FORM, label: t.ONBOARDING_STEPS.LABELS.FORM },
    {
      key: OnboardingStep.PHOTO_UPLOAD,
      label: t.ONBOARDING_STEPS.LABELS.PHOTOS,
    },
    {
      key: OnboardingStep.FACE_VERIFICATION,
      label: t.ONBOARDING_STEPS.LABELS.FACE,
    },
  ];

  const currentIndex = steps.findIndex((s) => s.key === step);

  return (
    <div className="w-full max-w-md mx-auto mb-12 px-2">
      <div className="relative">
        <div className="absolute top-2 left-0 right-0 h-2 bg-zinc-800 rounded-full" />

        <motion.div
          className="absolute top-2 left-0 h-2 bg-zinc-200 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${(currentIndex / (steps.length - 1)) * 100}%` }}
          transition={{ duration: 0.4 }}
        />

        {/* Step Dots */}
        <div className="relative z-10 flex justify-between items-center">
          {steps.map((s, i) => {
            const isActive = i <= currentIndex;
            return (
              <div key={s.key} className="relative flex flex-col items-center">
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold
                  ${isActive ? "bg-zinc-200 text-black" : "bg-zinc-700"}`}
                >
                  {i + 1}
                </div>
                <span className="absolute top-8 w-max text-sm text-center whitespace-nowrap">
                  {s.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
